import { useState, useEffect } from 'react'

const useFilteredData = (initialData) => {
  const [data, setData] = useState(initialData)

  const filterData = (search) => {
    const lowerCaseSearch = search.toLowerCase()

    if (search.length === 0) {
      setData(initialData)
    } else {
      const filteredTable = initialData.filter((item) =>
        Object.values(item).some(
          (value) => value?.toString().toLowerCase().includes(lowerCaseSearch),
        ),
      )

      setData(filteredTable)
    }
  }

  useEffect(() => {
    setData(initialData)
  }, [initialData])

  useEffect(() => {
    console.log('filteredData', data)
  }, [data])

  return { filteredData: data, filterData }
}

export default useFilteredData
